<template>
  <div id="SaleProductManager">
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div
            class="vx-col lg:w-5/6 w-full mb-6"
            v-has-permission="permission45"
          >
            <label class="vs-select--label">{{ $t("UserName") }}</label>
            <treeselect
              name="user"
              :multiple="false"
              :placeholder="$t('SearchUser')"
              :async="true"
              :load-options="loadUserOptions"
              ref="user"
              @select="onUserSelected"
            />
          </div>
          <div class="vx-col lg:w-1/6 w-full">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="add-btn mt-6"
              @click.prevent="addSaleProductManager"
            ></vs-button>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('SaleProductManagerFullName') },
                { title: $t('User') },
                { title: $t('CreateOn') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 22%">
                  {{ row.firstName }}
                </td>
                <td style="width: 22%">
                  {{ row.userName }}
                </td>
                <td style="width: 19%; direction: ltr">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
                <td style="width: 35%">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="bordered-btn"
                    @click.prevent="contractsPopup(row)"
                    v-has-permission="permission41"
                    >{{ $t("SaleContracts") }}</vs-button
                  >
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="bordered-btn"
                    @click.prevent="productSegmentsPopup(row)"
                    v-has-permission="permission43"
                    >{{ $t("ProductSegments") }}</vs-button
                  >
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteSaleProductManager(row.id)"
                    class="d-inline mr-4"
                    v-has-permission="permission44"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
        <contracts-popup
          :show="showContractsPopup"
          :model="moodalModel"
          @finish="onContractModalfinish"
        ></contracts-popup>
        <segments-popup
          :show="showSegmentsPopup"
          :model="moodalModel"
          @finish="onSegmentModalfinish"
        ></segments-popup>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.add-btn:hover i {
  color: #fff !important;
}

#SaleProductManager .bordered-btn:hover {
  color: #097272 !important;
}

.bordered-btn {
  margin: 0 5px !important;
}
</style>
<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DataGrid from "@/components/datagrid/DataGrid";
import ContractsPopup from "./ContractsPopup.vue";
import SegmentsPopup from "./SegmentsPopup.vue";

const dict = {
  custom: {
    customer: {
      required: "لطفا نام مشتری را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_SaleProductManagers_Index",

  components: {
    Treeselect,
    DataGrid,
    ContractsPopup,
    SegmentsPopup,
  },
  data() {
    return {
      permission41: "",
      permission43: "",
      permission44: "",
      permission45: "",
      model: {
        userId: null,
        userName: "",
        firstName: "",
        lastName: "",
      },
      disabled: false,
      gridDataSource: {
        type: "app",
        service: "Sales/api/SaleProductManagerQuery",
      },
      gridSearchData: {},
      showContractsPopup: false,
      showSegmentsPopup: false,
      moodalModel: {},
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  methods: {
    ...mapActions({
      searchCustomerByPhone: "identityAccess/searchCustomerByPhone",
      createSaleProductManager: "sale/createSaleProductManager",
      removeSaleProductManager: "sale/deleteSaleProductManager",
    }),
    loadUserOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.searchCustomerByPhone(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.id,
                  userName: element.userName,
                  label: element.userName,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onUserSelected(data) {
      this.model.userId = data.id;
      this.model.userName = data.userName;
    },
    addSaleProductManager() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createSaleProductManager(this.model)
            .then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$refs.user.clear();
              this.$refs.grid.renderGrid();
            })
            .catch(() => {
              this.$refs.user.clear();
              this.disabled = false;
            });
        }
      });
    },
    deleteSaleProductManager(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeSaleProductManager(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    contractsPopup(model) {
      this.moodalModel = {
        saleProductManagerId: model.id,
        saleProductManagerName: model.firstName
          ? model.firstName + " " + model.lastName
          : "",
      };
      this.showContractsPopup = true;
    },
    onContractModalfinish() {
      this.showContractsPopup = false;
    },
    productSegmentsPopup(model) {
      this.moodalModel = {
        saleProductManagerId: model.id,
        saleProductManagerName: model.firstName
          ? model.firstName + " " + model.lastName
          : "",
      };
      this.showSegmentsPopup = true;
    },
    onSegmentModalfinish() {
      this.showSegmentsPopup = false;
    },
  },
};
</script>
